module.exports = __webpack_public_path__ + "static/media/login-bg.26083255.jpg";